(()=>{
  const setup=(root=document)=>{
    document.documentElement.classList.add('pw-motion-ready');
    const cards=[...root.querySelectorAll('.pw-showcase-card.pw-reveal')];
    if(!cards.length)return;
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}
      }),{threshold:.08,rootMargin:'0px 0px -4% 0px'});
      cards.forEach(card=>{card.classList.remove('is-visible');observer.observe(card)});
      setTimeout(()=>cards.forEach(card=>card.classList.add('is-visible')),1800);
    }else cards.forEach(card=>card.classList.add('is-visible'));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
